/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForCloud extends models.ServiceAccountNativeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForCloud");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForCloud.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForCloud>): ServiceAccountNativeDetailsBaseForCloud {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForCloud(), model);
        ServiceAccountNativeDetailsBaseForCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForCloud>): ServiceAccountNativeDetailsBaseForCloud {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForCloud.newInstance(<ServiceAccountNativeDetailsBaseForCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForCloud) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForCloud): boolean {
        if (models.ServiceAccountNativeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.servicenow_cmdb_configuration) {
            models.ServiceNowCmdbConfigCreateRequest.fixupPrototype(this.servicenow_cmdb_configuration);
        }
    }

    /**
     * Cloud access type to select
     */
    access_type: models.CloudAccountAccessType;

    /**
     * ServiceNow CMDB Configuration
     */
    servicenow_cmdb_configuration: models.ServiceNowCmdbConfigCreateRequest;

}
